import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_DIGITAL_TWIN_INLCM_2 = {
  title: `<span style="color: #BEE3FF;">Generate the proposed network plan</span>\n\nSummary view of proposed network plan \nfor all the sites.`,
  subtitle: "Digital Twin for Network Transformation",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ENG_312"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_310"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/INLCM/INLCM_dark_bg_2.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "ENG/INLCM/INLCM_digital_twin_01_computer.png",
          effect: "animate-opacity",
          imageStyle: { position: "absolute", bottom: "160px", right: "0px" },
        },
        {
          image: "ENG/INLCM/INLCM_digital_twin_02_screen.png",
          imageStyle: { position: "absolute", bottom: "235px", right: "83px" },
        },
        {
          image: "ENG/INLCM/INLCM_digital_twin_02_finger.png",
          imageStyle: { position: "absolute", bottom: "82px", right: "699px" },
        },
      ]}
      pageNumber={"ENG_311"}
    />
  ),
};
